module.exports = {
          srcSet: __webpack_public_path__ + "public/770d27c4d06549281918c6ac105dab4e-56.png"+" 56w",
          images:[ {path: __webpack_public_path__ + "public/770d27c4d06549281918c6ac105dab4e-56.png",width: 56,height: 54}],
          src: __webpack_public_path__ + "public/770d27c4d06549281918c6ac105dab4e-56.png",
          toString:function(){return __webpack_public_path__ + "public/770d27c4d06549281918c6ac105dab4e-56.png"},
          
          width: 56,
          height: 54
        }